export const UpgradeMessage = "ZK_7cb";
export const ManageSubscriptionMessage = "x1PKFc";
export default {UpgradeMessage,ManageSubscriptionMessage};